import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FormItemContainer } from '@/components'
import { Form, Input, message, Typography, Button } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { BlockButton } from '../login/direct-login'
import { ReturnLogin } from '../login/forget-pwd'
import { useReset, usePasswordLength } from './util'
import { Message } from '@/components/message'
import { t } from '@/i18n'
const { useForm } = Form
export const ResetPwd = () => {
  const navigate = useNavigate()
  const [form] = useForm()
  const [reset] = useReset()
  // const [passwordLength] = usePasswordLength()
  const [passLength, setPassLength] = useState(8)
  let search = window.location.search.split('email=')[1]

  // useEffect(() => {
  //   passwordLength()
  //     .then(res => {
  //       console.log('data', res.data)
  //       setPassLength(res.data.password_length || 8)
  //     })
  //     .catch(_ => {})
  // }, [])
  const loginHandler = (values: any) => {
    const { password } = values
    reset({
      email: search.slice(0, search.indexOf('&')),
      email_token: search.slice(search.indexOf('mail_token=') + 11),
      password,
    })
      .then(res => {
        localStorage.removeItem('token')
        Message.success(t('修改密码成功'))
        navigate('/login')
      })
      .catch(err => {})
  }
  return (
    <Direct>
      {/* <ResetPwdText>重新设置密码</ResetPwdText> */}
      <Form onFinish={loginHandler} form={form}>
        <FormItemContainer>
          <Form.Item
            name="password"
            hasFeedback
            rules={[
              {
                required: true,
                message: t('请输入密码'),
              },
              {
                pattern: new RegExp(
                  `^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_]+$)(?![a-z0-9]+$)(?![a-z\\W_]+$)(?![0-9\\W_]+$)[a-zA-Z0-9\\W_]{${passLength},}$`,
                ),
                message: `${t('密码长度最低为')} ${passLength} ${t(
                  '位，必须包含以下至少三种字符: 大写字母、小写字母、特殊字符或数字组合',
                )}`,
              },
              { max: 999, message: t('密码长度最大为999位') },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgb(51, 51, 51)' }} />}
              placeholder={t('设置新密码')}
            />
          </Form.Item>
        </FormItemContainer>
        <FormItemContainer>
          <Form.Item
            name="confirm"
            dependencies={['password']}
            hasFeedback
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (getFieldValue('password') === value) {
                    return Promise.resolve()
                  }
                  if (!value) {
                    return Promise.reject(new Error(t('请再次输入密码')))
                  }
                  return Promise.reject(new Error(t('两次密码不一致')))
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgb(51, 51, 51)' }} />}
              placeholder={t('请再次输入密码')}
            />
          </Form.Item>
        </FormItemContainer>
        <ConfirmBtn>
          <Button className="confirmBtn" block onClick={() => form.submit()}>
            {t('更改密码')}
          </Button>
        </ConfirmBtn>
        <ReturnLogin>
          <Typography.Link
            onClick={() => {
              localStorage.removeItem('token')
              // setLoginStatus('direct-login')
              navigate('/login')
            }}
            className="retrieve"
          >
            {t('返回登录')}
          </Typography.Link>
        </ReturnLogin>
      </Form>
    </Direct>
  )
}

const ResetPwdText = styled.div`
  font-weight: 600;
  margin-bottom: 15px;
  color: #d0d0d0;
`
const Direct = styled.div`
  .ant-input-affix-wrapper,
  .ant-input {
    height: 36px;
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
    .ant-input-prefix ~ input {
      margin-top: -6px;
      height: 33px;
    }
  }
  margin-top: 40px;
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    -webkit-text-fill-color: #4238c9 !important;
    background-color: #4238c9;
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  input {
    background-color: transparent;
  }
  .confirmBtn {
    height: 38px;
    background: #4238c9;
    border: 1px solid #4238c9;
    color: #fff;
    &::after {
      display: none;
    }
    :hover {
      background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
      border: none;
    }
  }
  .retrieve {
    cursor: pointer;
    color: #666666;
    &:hover {
      color: #807ddb;
    }
  }
`
const ConfirmBtn = styled.div`
  height: 38px;
  background: #4238c9;
  border-radius: 6px;
  line-height: 38px;
  color: #fff;
  :hover {
    background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
    border: none;
  }
`
